import development from "./development";
import production from "./production";
import staging from "./staging";
export function getConfig(env) {
    switch (env) {
        case "production":
            return production;
        case "staging":
            return staging;
        case "development":
        default:
            return development;
    }
}
export const config = getConfig(process.env.REACT_APP_ENVIRONMENT || "development");
export { staging, production, development };
//# sourceMappingURL=index.js.map